import { instance } from '@/shared/lib/clientAxios';
import { useInfiniteQuery } from '@tanstack/react-query';

export const useAddressSearchBuddyData = (groupSeqNo: string, keyword?: string) => {
  const fetchGroupBuddyList = async ({ pageSize, groupSeqNo, keyword, pageNumber }: any) => {
    try {
      const response = await instance.get('/groupBuddyList', {
        params: {
          pageSize,
          groupSeqNo,
          keyword,
          pageNumber,
        },
      });
      return response.data; // 응답 데이터 반환
    } catch (error) {
      console.error('Error fetching buddy list:', error);
      throw new Error('Failed to fetch buddy list'); // 에러 처리
    }
  };

  // Infinite query to fetch buddy list
  const { data, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage, refetch, isFetching } = useInfiniteQuery(
    ['groupBuddyList', keyword, groupSeqNo],
    ({ pageParam = 0 }) =>
      fetchGroupBuddyList({
        pageSize: 10,
        groupSeqNo,
        keyword,
        pageNumber: pageParam,
      }),
    {
      getNextPageParam: (lastPage, pages) => {
        return pages.length < lastPage.totalPages ? pages.length + 1 : undefined; // 페이지 인덱스 증가
      },
    },
  );

  const buddyListData = data ? data.pages.flatMap((page) => page.content) : [];
  return {
    buddyListData,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
    isLoading,
  };
};
